import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Grid from '@mui/material/Grid2'
import {
  DescriptionOutlined,
  GavelOutlined,
  HowToRegOutlined,
  ReceiptLongOutlined,
  RouteOutlined,
} from '@mui/icons-material'

import {
  findCardMetaType,
  findCardType,
  transformTallyData,
  transformProductGroupedStack,
  transformProductSegmentData,
} from '../dash-util';
import { TotalCard } from '../cards/TotalCard';
import GroupedStackedColumn from '../charts/GroupedStackedColumn';
import { ProductSegmentCard } from '../cards/ProductSegmentCard';
import { CustomsDocumentStatusCard } from '../cards/CustomsDocumentStatusCard';

export function CustomsView({ cardsData, regressionData,  productData, periodFilter, setPeriodFilter }) {

  const [groupedStacked, setGroupedStacked] = useState([]);
  const [showGroupedLegend, setShowGroupedLegend] = useState(false);

  const documentCardConfig = [
    { type: 'Nominations', label: 'Nominations', icon: HowToRegOutlined, accent: '#2563eb' },
    { type: 'SARS Customs', label: 'SARS', icon: GavelOutlined, accent: '#7c3aed' },
    { type: 'Releases', label: 'Releases', icon: DescriptionOutlined, accent: '#0ea5e9' },
    { type: 'Commercial Invoices', label: 'Commercial Invoice', icon: ReceiptLongOutlined, accent: '#f59e0b' },
    { type: 'Transit Clearance', label: 'Transit Clearance', icon: RouteOutlined, accent: '#22c55e' },
  ];

  const getDocumentStats = (cardType) => {
    const details = findCardType(cardsData, cardType);
    const sent = Number(findCardMetaType(details?.metadata, 'Sent')?.value || 0);
    const outstanding = Number(findCardMetaType(details?.metadata, 'Outstanding')?.value || 0);

    return { sent, outstanding };
  };

  useEffect(() => {
    const _gStacked = transformProductGroupedStack(regressionData);
    setGroupedStacked(_gStacked);

    const showLegend = !_gStacked.series.every((item) => item.data.length === 0);
    setShowGroupedLegend(showLegend);

  }, [cardsData, regressionData, productData, periodFilter]);

  return (
    <>
    <Grid container spacing={3}>
      <Grid size={{ lg: 3, sm: 6, xs: 12 }} key='In-Bond Suborders'>
        <TotalCard
          sx={{ height: '100%' }}
          data={transformTallyData(cardsData, 'In-Bond Suborders')}
        />
      </Grid>

      <Grid size={{ lg: 3, sm: 6, xs: 12 }} key='Direct Suborders'>
        <TotalCard
          sx={{ height: '100%' }}
          data={transformTallyData(cardsData, 'Direct Suborders')}
        />
      </Grid>

      {documentCardConfig.map((config) => {
        const stats = getDocumentStats(config.type);
        return (
          <Grid size={{ lg: 4, sm: 6, xs: 12 }} key={config.type}>
            <CustomsDocumentStatusCard
              title={config.type}
              displayTitle={config.label}
              sent={stats.sent}
              outstanding={stats.outstanding}
              accent={config.accent}
              icon={config.icon}
              sx={{ height: '100%' }}
            />
          </Grid>
        );
      })}
    </Grid>
    <Grid container spacing={3} sx={{mt: 3}}>

      <Grid size={{ xs: 8 }} key="grouped stacked">
      {/* <AreaChart /> */}
      <GroupedStackedColumn
        series={groupedStacked.series}
        categories={groupedStacked.categories}
        height={350}
        title={"Supplier Product Ordered"}
        periodFilter={periodFilter}
        setPeriodFilter={setPeriodFilter}
        showLegend={showGroupedLegend}
      />
    </Grid>

    <Grid size={{ xs: 4 }} key="product segment">
      <ProductSegmentCard
        products={transformProductSegmentData(productData)}
        periodFilter={periodFilter}
        setPeriodFilter={setPeriodFilter}
        sx={{ height: '100%' }}
      />
    </Grid>
    </Grid>
  </>
  )
}

CustomsView.propTypes = {
  cardsData: PropTypes.arrayOf(PropTypes.object).isRequired,
  regressionData: PropTypes.object,
  productData: PropTypes.object,
  periodFilter: PropTypes.string,
  setPeriodFilter: PropTypes.func,
}
